import styled from "styled-components";

export const Container = styled.div`
    min-height: calc(100vh - 56px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
 

    h2 {
        font-size: 10rem;
    }

    p {
        font-size: 3rem;
    }
`
